module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_16.a6dbe093.jpg";